import { apiClient } from "./ApiClient";

export async function createWalletOrder({ internalPackageId, walletId, promocode = null }) {
  const params = {
    package_id: internalPackageId,
    wallet_id: walletId,
    promocode: promocode || null,
  };

  const { data } = await apiClient.post("/order/", null, { params });
  console.log("✅ Wallet Direct Order:", data);
  return data;
}

export async function initiateGuestOrder({ internalPackageId, userId, frontendUrl }) {
  const params = {
    package_id: internalPackageId,
    user_id: userId,
    frontend_url: frontendUrl,
    provider: "stripe",
    // newsletter: newsletter,
  };

  const { data } = await apiClient.post("/order/guest/init", null, { params });

  console.log("✅ Guest order:", data);
  return data;
}

export async function initiateUserStripeOrder({ internalPackageId, walletId, frontendUrl, promocode = null }) {
  const body = {
    package_id: internalPackageId,
    wallet_id: walletId,
    frontend_url: frontendUrl,
    promocode: promocode || null,
    provider: "stripe",
  };

  const { data } = await apiClient.post("/order/init", body, {});
  console.log("✅ User Stripe order:", data);
  return data;
}
